import React from 'react';
import { NavLink } from 'react-router-dom';
import PageHeader from '../components/common/PageHeader';
import Business from './Business';
import Projects from './Projects';

const TABS = [
    { key: 'client', label: 'Client Projects', to: '/business' },
    { key: 'internship', label: 'Internship Projects', to: '/projects' }
];

/**
 * Client projects (/business) and internship projects (/projects) on one
 * page. Each tab keeps its own URL so existing links, bookmarks and the
 * detail pages' "back" links keep working.
 */
export default function ProjectsHub({ tab }) {
    return (
        <div className="w-full space-y-6">
            <PageHeader
                title="Projects"
                description="Your client projects with real businesses and your internship projects, in one place."
                className="!mb-0"
            />

            <nav role="tablist" aria-label="Project type" className="flex gap-1 overflow-x-auto border-b border-border">
                {TABS.map((t) => (
                    <NavLink
                        key={t.key}
                        to={t.to}
                        end
                        role="tab"
                        aria-selected={tab === t.key}
                        className={`whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${tab === t.key
                            ? 'border-brand-700 text-brand-800'
                            : 'border-transparent text-ink-600 hover:text-ink-900'}`}
                    >
                        {t.label}
                    </NavLink>
                ))}
            </nav>

            {tab === 'client' ? <Business embedded /> : <Projects embedded />}
        </div>
    );
}
